import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { MoonLoader } from "react-spinners";

function Loader({ isLoading }) {
  return (
    <Modal
      size="sm"
      aria-labelledby="example-modal-sizes-title-sm contained-modal-title-vcenter"
      centered
      show={isLoading}
      className="modal-transparent modal-fullscreen"
    >
      <div className="bg-white rounded-2 d-flex align-items-center" style={{width: 120, height:120}}>
      <MoonLoader className="mx-auto my-4" color="#6c62ff" size={30} />
      </div>
    </Modal>
  );
}

export default Loader;
